module.exports = __webpack_public_path__ + "img/home_part4_book.e584ddeb.png";